goog.provide('el8.data.visitNoteFormTemplates');

goog.require('el8.app.pageLayout');
goog.require('el8.appchart.visitNote.vitalFields');
goog.require('el8.template.data.visitNoteFormTemplates');
goog.require('el8.util.consts');

/**
 * ==========
 * SOME RULES
 * ==========
 *  - If either "test" or "tx" is missing, then addOwnedDocs needs to be true
 *  - If any section to which documents can be ref'd is a textarea, then addAssociatedDocs
 *    needs to be true
 *  - mapOwnedDocFn needs to return one of "test", "tx", "med", "plan", or "orders"
 *  - assessPlan cannot show in twoCol mode
 *  - not enforced in code, but expect every template to have "Reason" field and billing section
 *  - THERE IS A DUP OF SOME OF THIS LOGIC IN notes/templates_ui_logic.py
 *
 * =======================
 * HOW TO ADD NEW CATEGORY
 * =======================
 * basics to store data:
 *  - add to ptdata/model/note/visit.js
 *  - add to elation/notes/models.py
 * for visit note form:
 *  - add stub to data.visitNoteFormTemplates.html
 *  - add template to appchart.visitNote.oneCol.html / appchart.visitNote.twoCol.html
 *  - add to sectionTypeMap of templates in template_ui_logic.py
 *  - add spec to sectionMap in appchart/visitNote/main.js
 *  - add to prePopulate in appchart/visitNote/main.js
 * for rendering in chart feed:
 *  - add spec to ptdata/model/note/asSoyMap.js
 *  - add spec to render.chartFeedItem.visitNoteContent.html
 * for printing:
 *  - add spec to print.visitNote.html
 *  - update templates_ui_logic.py
 */

el8.data.visitNoteFormTemplates.getByIdentifier = function(str) {
    // str is e.g. oneCol.simple, twoCol.complex
    if (!str) { return null; }
    var strs = str.split('.');
    if (strs.length < 2) { return null; }
    return el8.data.visitNoteFormTemplates[strs[0]][strs[1]];
};

el8.data.visitNoteFormTemplates.all = function(doSuppress) {
    var r = [];
    var types = ['twoCol', 'oneCol'];
    for (var i=0; i<types.length; i++) {
        var templateClass = el8.data.visitNoteFormTemplates[types[i]];
        for (var sub in templateClass) {
            if (templateClass.hasOwnProperty(sub)) {
                if (!doSuppress || !templateClass[sub]['suppress']) {
                    r.push({
                        type: types[i]+'.'+sub,
                        displayName: templateClass[sub]['displayName']
                    });
                }
            }
        }
    }
    return r;
};

el8.data.visitNoteFormTemplates.getClass = function(str) {
    // str is e.g. oneCol.simple, twoCol.complex
    if (!str) { return null; }
    var strs = str.split('.');
    if (strs.length < 2) { return null; }
    return strs[0];
};

el8.data.visitNoteFormTemplates._initVitals = function(note) {

    var getFieldForVital = el8.appchart.visitNote.vitalFields.getFieldForVital; // shorthand

    // These need to be added after the model is set
    note._addVitals('bp_0', getFieldForVital('bp_0'), 'bp', '.bp-input[_bpindex="0"]');
    note._addVitals('hr', getFieldForVital('hr'));
    note._addVitals('rr', getFieldForVital('rr'));
    note._addVitals('temperature', getFieldForVital('temperature'));
    note._addVitals('weight', getFieldForVital('weight'));
    note._addVitals('height', getFieldForVital('height'));
    note._addVitals('oxygen', getFieldForVital('oxygen'));
    note._addVitals('hc', getFieldForVital('hc'));
    note._addVitals('pain', getFieldForVital('pain'));

    if (el8.data.practiceSettings.isAdditionalVitalsEnabled()) {
        el8.util.consts.ADDITIONAL_VITALS.forEach(function(customVital) {
            note._addVitals(customVital, getFieldForVital(customVital));
        });
    }
};

el8.data.visitNoteFormTemplates.twoCol = {
    complex : {
        displayName: 'Complete H&P Note (2 column)',
        focusFieldName: 'problem',
        formTemplateFn: function(spec) {
            var spec = spec || {};
            _.extend(spec, {
                displayPatientAge: el8.ptdata.currPatient.getDisplayAge(),
                patientAge: el8.ptdata.currPatient.getAge(),
                additionalVitals: el8.data.practiceSettings.isAdditionalVitalsEnabled()
            });
            return el8.template.data.visitNoteFormTemplates.twoCol(spec);
        },
        mapReferenceFn: function(sectionName, item) {
            if (item && item.is('PatientAllergy') && !sectionName) {
                return 'allergies';
            }
            return sectionName;
        },
        mapOwnedDocFn: function(doc) {
            if (doc.is('MedOrder') && doc.isDocumentMed()) {
                return 'med';
            }
            if (doc.is('DiscontinueMedOrder') && doc.isDocumented()) {
                return 'med';
            }
            var mClass = doc.getModelClass();
            var map = {
                'LabOrder': 'test',
                'ImagingOrder': 'test',
                'CardiacOrder': 'test',
                'PulmonaryOrder': 'test',
                'SleepOrder': 'test',
                'ReferralOrder': 'tx',
                'DiscontinueMedOrder': 'tx',
                'MedOrder': 'tx'
            };
            return map[mClass];
        },
        /* This sectionTypeMap is only needed when displaying visit notes */
        sectionTypeMap: el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'] ? 
            el8Globals['VISIT_NOTE_SECTION_TYPE_MAP']['twoCol.complex'] : {},
        showFn: function(note, sectionsMap) {

            var map = el8.data.visitNoteFormTemplates.twoCol.complex.sectionTypeMap;

            for (var section in map) {
                if (map.hasOwnProperty(section)) {
                    note._addInputSection(section, map[section]);
                }
            }

            note._addLinksSection('test');
            note._addLinksSection('tx');
            note._addLinksSection('med');
            note._addLinksSection('problem');
            note._addLinksSection('past');
            note._addLinksSection('surgical');
            note._addLinksSection('family');
            note._addLinksSection('social');
            note._addLinksSection('habits');
            note._addLinksSection('allergies');
            note._addLinksSection('data');

            note._addBillingSection();
        }
    },
    complex2 : {
        displayName: 'Complete H&P Note (2 col-A/P)',
        focusFieldName: 'problem',
        formTemplateFn: function() {
            return el8.template.data.visitNoteFormTemplates.twoCol({
                displayPatientAge: el8.ptdata.currPatient.getDisplayAge(),
                patientAge: el8.ptdata.currPatient.getAge(),
                combineAssessmentPlan: true,
                additionalVitals: el8.data.practiceSettings.isAdditionalVitalsEnabled()
            });
        },
        mapReferenceFn: function(sectionName) {
            if (sectionName === 'assessment' ||
                sectionName === 'tx' ||
                sectionName === 'test') {
                return 'assessplan';
            }
            return sectionName;
        },
        mapOwnedDocFn: function(doc) {
            if (doc.is('MedOrder') && doc.isDocumentMed()) {
                return 'med';
            }
            if (doc.is('DiscontinueMedOrder') && doc.isDocumented()) {
                return 'med';
            }
            return 'orders';
        },
        /* This sectionTypeMap is only needed when displaying visit notes */
        sectionTypeMap: el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'] ? 
            el8Globals['VISIT_NOTE_SECTION_TYPE_MAP']['twoCol.complex2'] : {},
        showFn: function(note, sectionsMap) {

            var map = el8.data.visitNoteFormTemplates.twoCol.complex2.sectionTypeMap;

            for (var section in map) {
                if (map.hasOwnProperty(section)) {
                    note._addInputSection(section, map[section]);
                }
            }

            note._addLinksSection('plan');
            note._addLinksSection('med');
            note._addLinksSection('past');
            note._addLinksSection('surgical');
            note._addLinksSection('family');
            note._addLinksSection('social');
            note._addLinksSection('habits');
            note._addLinksSection('problem');
            note._addLinksSection('allergies');
            note._addLinksSection('data');

            note._addBillingSection();
        }
    }
};

el8.data.visitNoteFormTemplates.oneCol = {
    simple : {
        displayName: 'SOAP Note',
        focusFieldName: 'problem',
        formTemplateFn: function() {
            return el8.template.data.visitNoteFormTemplates.oneCol({
                isVitalsHidden: true,
                displayPatientAge: el8.ptdata.currPatient.getDisplayAge(),
                patientAge: el8.ptdata.currPatient.getAge(),
                additionalVitals: el8.data.practiceSettings.isAdditionalVitalsEnabled()
            });
        },
        mapReferenceFn: function(sectionName) {
            var map = {
                'data': 'objective',
                'med': 'problem',
                'test': 'plan',
                'tx': 'plan',
                'past': 'problem',
                'surgical': 'problem',
                'family': 'problem',
                'social': 'problem',
                'habits': 'problem',
                'assessplan': 'assessment',
                'hpi': 'problem',
                'allergies': 'problem'
            };
            return map[sectionName] || sectionName;
        },
        mapOwnedDocFn: function(doc) {
            return 'orders';
        },
        /* This sectionTypeMap is only needed when displaying visit notes */
        sectionTypeMap: el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'] ? 
            el8Globals['VISIT_NOTE_SECTION_TYPE_MAP']['oneCol.simple'] : {},
        sectionHiddenMap: {
            'instr': true,
            'procedure': true,
            'pe': true,
            'ros': true
        },
        showFn: function(note) {

            var typeMap = el8.data.visitNoteFormTemplates.oneCol.simple.sectionTypeMap;
            var hiddenMap = el8.data.visitNoteFormTemplates.oneCol.simple.sectionHiddenMap;

            for (var section in typeMap) {
                if (typeMap.hasOwnProperty(section)) {
                    note._addInputSection(section, typeMap[section], hiddenMap[section]);
                }
            }

            note._addBillingSection();
            note._addLinksSection('plan');
            note._addLinksSection('med');
        }
    },
    oneField: {
        displayName: 'Simple Note',
        focusFieldName: 'narrative',
        formTemplateFn: function() {
            return el8.template.data.visitNoteFormTemplates.oneCol({
                isVitalsHidden: true,
                pinVitalsToTop: true,
                displayPatientAge: el8.ptdata.currPatient.getDisplayAge(),
                patientAge: el8.ptdata.currPatient.getAge(),
                additionalVitals: el8.data.practiceSettings.isAdditionalVitalsEnabled()
            });
        },
        mapReferenceFn: function(sectionName) {
            if (sectionName === 'instr') { return 'instr'; }
            if (sectionName === 'procedure') { return 'procedure'; }
            return 'narrative';
        },
        mapOwnedDocFn: function(doc) {
            return 'orders';
        },
        /* This sectionTypeMap is only needed when displaying visit notes */
        sectionTypeMap: el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'] ? 
            el8Globals['VISIT_NOTE_SECTION_TYPE_MAP']['oneCol.oneField'] : {},
        sectionHiddenMap: {
            'instr': true,
            'procedure': true
        },
        showFn: function(note) {
            var typeMap = el8.data.visitNoteFormTemplates.oneCol.oneField.sectionTypeMap;
            var hiddenMap = el8.data.visitNoteFormTemplates.oneCol.oneField.sectionHiddenMap;
            for (var section in typeMap) {
                if (typeMap.hasOwnProperty(section)) {
                    note._addInputSection(section, typeMap[section], hiddenMap[section]);
                }
            }
            note._addBillingSection();
            note._addLinksSection('plan');

            // try to take up most of the visit section, with some buffer above and below
            var desiredNarrativeFieldHeight = el8.app.pageLayout.getAppInnerHeight() - 500;
            // but if the page is really short, that might end up being a very small number. Set a min.
            var narrativeFieldHeight = Math.max(200, desiredNarrativeFieldHeight);
            note.getForm().getInfoField('narrative')
                .getInputField().height(narrativeFieldHeight);
        }
    },
    preOp: {
        displayName: 'Complete H&P Note (1 column)',
        focusFieldName: 'hpi',
        formTemplateFn: function() {
            return el8.template.data.visitNoteFormTemplates.oneCol({
                isVitalsHidden: true,
                displayPatientAge: el8.ptdata.currPatient.getDisplayAge(),
                patientAge: el8.ptdata.currPatient.getAge(),
                additionalVitals: el8.data.practiceSettings.isAdditionalVitalsEnabled()
            });
        },
        mapReferenceFn: function(sectionName, item) {
            if (item) {
                if (item.is('PatientHistoryItem') && item.getType() === 'Habits') {
                    return 'habits';
                }
                if (item.is('PatientAllergy') && !sectionName) {
                    return 'allergies';
                }
            }
            if (sectionName === 'assessment' ||
                sectionName === 'assessplan' ||
                sectionName === 'tx' ||
                sectionName === 'plan' ||
                sectionName === 'test') {
                return 'assessplan';
            }
            if (sectionName === 'med' ||
                sectionName === 'past' ||
                sectionName === 'surgical' ||
                sectionName === 'family' || 
                sectionName === 'social' ||
                sectionName === 'instr' ||
                sectionName === 'procedure' ||
                sectionName === 'pe' || (sectionName || '').startswith('pe') || 
                sectionName === 'ros' || (sectionName || '' ).startswith('ros') ||
                sectionName === 'allergies' ||
                sectionName === 'data' ||
                sectionName === 'habits') {
                return sectionName;
            }
            return 'hpi';
        },
        mapOwnedDocFn: function(doc) {
            if (doc.is('MedOrder') && doc.isDocumentMed()) {
                return 'med';
            }
            if (doc.is('DiscontinueMedOrder') && doc.isDocumented()) {
                return 'med';
            }
            return 'orders';
        },
        /* This sectionTypeMap is only needed when displaying visit notes */
        sectionTypeMap: el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'] ? 
            el8Globals['VISIT_NOTE_SECTION_TYPE_MAP']['oneCol.preOp'] : {},
        sectionHiddenMap: {
            'instr': true,
            'procedure': true
        },
        showFn: function(note) {
            var typeMap = el8.data.visitNoteFormTemplates.oneCol.preOp.sectionTypeMap;
            var hiddenMap = el8.data.visitNoteFormTemplates.oneCol.preOp.sectionHiddenMap;
            for (var section in typeMap) {
                if (typeMap.hasOwnProperty(section)) {
                    note._addInputSection(section, typeMap[section], hiddenMap[section]);
                }
            }
            note._addLinksSection('past');
            note._addLinksSection('surgical');
            note._addLinksSection('med');
            note._addLinksSection('plan');
            note._addLinksSection('family');
            note._addLinksSection('social');
            note._addLinksSection('habits');
            note._addLinksSection('allergies');
            note._addLinksSection('data');
            note._addBillingSection();
        }
    },
    preOp2: {
        displayName: 'Pre-Op Note',
        focusFieldName: 'hpi',
        formTemplateFn: function() {
            return el8.template.data.visitNoteFormTemplates.oneCol({
                isVitalsHidden: true,
                displayPatientAge: el8.ptdata.currPatient.getDisplayAge(),
                patientAge: el8.ptdata.currPatient.getAge(),
                additionalVitals: el8.data.practiceSettings.isAdditionalVitalsEnabled()
            });
        },
        mapReferenceFn: function(sectionName, item) {
            if (item) {
                if (item.is('PatientHistoryItem') && item.getType() === 'Habits') {
                    return 'habits';
                }
                if (item.is('PatientAllergy') && !sectionName) {
                    return 'allergies';
                }
            }
            if (sectionName === 'assessment' ||
                sectionName === 'assessplan' ||
                sectionName === 'tx' ||
                sectionName === 'plan' ||
                sectionName === 'test') {
                return 'assessplan';
            }
            if (sectionName === 'med' ||
                sectionName === 'past' ||
                sectionName === 'surgical' ||
                sectionName === 'family' || 
                sectionName === 'social' ||
                sectionName === 'instr' ||
                sectionName === 'procedure' ||
                sectionName === 'pe' || (sectionName || '').startswith('pe') || 
                sectionName === 'ros' || (sectionName || '' ).startswith('ros') ||
                sectionName === 'allergies' ||
                sectionName === 'habits') {
                return sectionName;
            }
            return 'hpi';
        },
        mapOwnedDocFn: function(doc) {
            if (doc.is('MedOrder') && doc.isDocumentMed()) {
                return 'med';
            }
            if (doc.is('DiscontinueMedOrder') && doc.isDocumented()) {
                return 'med';
            }
            return 'orders';
        },
        /* This sectionTypeMap is only needed when displaying visit notes */
        sectionTypeMap: el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'] ? 
            el8Globals['VISIT_NOTE_SECTION_TYPE_MAP']['oneCol.preOp2'] : {},
        sectionHiddenMap: {
            'instr': true,
            'procedure': true
        },
        showFn: function(note) {
            var typeMap = el8.data.visitNoteFormTemplates.oneCol.preOp2.sectionTypeMap;
            var hiddenMap = el8.data.visitNoteFormTemplates.oneCol.preOp2.sectionHiddenMap;
            for (var section in typeMap) {
                if (typeMap.hasOwnProperty(section)) {
                    note._addInputSection(section, typeMap[section], hiddenMap[section]);
                }
            }
            note._addLinksSection('past');
            note._addLinksSection('surgical');
            note._addLinksSection('med');
            note._addLinksSection('plan');
            note._addLinksSection('family');
            note._addLinksSection('social');
            note._addLinksSection('habits');
            note._addLinksSection('allergies');
            note._addLinksSection('data');
            note._addBillingSection();
        }
    },
    complex: {  // added for PA import
        displayName: 'Complete H&P Note (1 column)',
        suppress: true,
        focusFieldName: 'hpi',
        formTemplateFn: function() {
            return el8.template.data.visitNoteFormTemplates.oneCol({
                isVitalsHidden: false,
                displayPatientAge: el8.ptdata.currPatient.getDisplayAge(),
                patientAge: el8.ptdata.currPatient.getAge(),
                additionalVitals: el8.data.practiceSettings.isAdditionalVitalsEnabled()
            });
        },
        mapReferenceFn: function(sectionName, item) {
            if (item) {
                if (item.is('PatientHistoryItem') && item.getType() === 'Habits') {
                    return 'habits';
                }
                if (item.is('PatientAllergy') && !sectionName) {
                    return 'allergies';
                }
            }
            if (sectionName === 'assessplan') {
                return 'assessment';
            }
            if (sectionName === 'tx' ||
                sectionName === 'test') {
                return 'plan';
            }
            if (sectionName === 'assessment' ||
                sectionName === 'plan' ||
                sectionName === 'med' ||
                sectionName === 'past' ||
                sectionName === 'surgical' ||
                sectionName === 'family' || 
                sectionName === 'social' ||
                sectionName === 'pe' || (sectionName || '').startswith('pe') || 
                sectionName === 'ros' || (sectionName || '' ).startswith('ros') ||
                sectionName === 'allergies' ||
                sectionName === 'data' ||
                sectionName === 'habits') {
                return sectionName;
            }
            return 'hpi';
        },
        mapOwnedDocFn: function(doc) {
            return 'orders';
        },
        /* This sectionTypeMap is only needed when displaying visit notes */
        sectionTypeMap: el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'] ? 
            el8Globals['VISIT_NOTE_SECTION_TYPE_MAP']['oneCol.complex'] : {},
        showFn: function(note) {
            var typeMap = el8.data.visitNoteFormTemplates.oneCol.complex.sectionTypeMap;
            for (var section in typeMap) {
                if (typeMap.hasOwnProperty(section)) {
                    note._addInputSection(section, typeMap[section]);
                }
            }
            note._addLinksSection('past');
            note._addLinksSection('surgical');
            note._addLinksSection('family');
            note._addLinksSection('social');
            note._addLinksSection('habits');
            note._addLinksSection('med');
            note._addLinksSection('plan');
            note._addLinksSection('allergies');
            note._addLinksSection('data');
            note._addBillingSection();
        }
    }
};



